export default {
  prevText: 'ä¸ä¸é¡µ',
  nextText: 'ä¸ä¸é¡µ',
};
